import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/users", {
    params,
  });

const get = ({id, ip}) => 
  authApi.post(`/users/getUser`, {
    id,
    ip
  });

const create = ({ name, areaCode, mobile}) =>
  authApi.post(`/users/adminCreate`, {
    name,
    areaCode,
    mobile,
  });

const update = ({ id, name, areaCode, mobile, priceReminderExpiryDate, clientId, status, userType }) =>
  authApi.put(`/users/adminUpdate`, {
    id,
    name,
    areaCode,
    mobile,
    clientId,
    priceReminderExpiryDate,
    status,
    userType
  });

export { getAll, get, create, update };
